module.exports = __webpack_public_path__ + "img/power-reader.2f723fc5.svg";